import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Pedestrian Crossings questions
export const pedestrianCrossingsMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-pc-1',
    text: {
      en: 'You are driving and see a pedestrian waiting at a zebra crossing. What should you do?',
      nl: 'Je rijdt en ziet een voetganger die wacht bij een zebrapad. Wat moet je doen?',
      ar: 'أنت تقود وترى أحد المشاة ينتظر عند معبر المشاة. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-pc-1o1',
        text: {
          en: 'Stop and give way to the pedestrian',
          nl: 'Stop en geef voorrang aan de voetganger',
          ar: 'توقف وأعط الأولوية للمشاة'
        }
      },
      {
        id: 'q-pc-1o2',
        text: {
          en: 'Continue driving, pedestrians must wait',
          nl: 'Blijf rijden, voetgangers moeten wachten',
          ar: 'استمر في القيادة، يجب على المشاة الانتظار'
        }
      },
      {
        id: 'q-pc-1o3',
        text: {
          en: 'Honk to warn the pedestrian',
          nl: 'Toeter om de voetganger te waarschuwen',
          ar: 'استخدم البوق لتحذير المشاة'
        }
      }
    ],
    correctAnswerId: 'q-pc-1o1',
    explanation: {
      en: 'At zebra crossings, you must stop and give way to pedestrians who are waiting to cross or already crossing. (RVV 1990 art. 49)',
      nl: 'Bij zebrapaden moet je stoppen en voorrang verlenen aan voetgangers die wachten om over te steken of al aan het oversteken zijn. (RVV 1990 art. 49)',
      ar: 'عند معابر المشاة، يجب عليك التوقف وإعطاء الأولوية للمشاة الذين ينتظرون العبور أو يعبرون بالفعل. (RVV 1990 art. 49)'
    },
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-2',
    text: {
      en: 'You are driving and see a pedestrian crossing at a traffic light. The light is green for you. What should you do?',
      nl: 'Je rijdt en ziet een voetganger die oversteekt bij een verkeerslicht. Het licht is groen voor jou. Wat moet je doen?',
      ar: 'أنت تقود وترى أحد المشاة يعبر عند إشارة مرور. الإشارة خضراء لك. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-pc-2o1',
        text: {
          en: 'Stop and give way to the pedestrian',
          nl: 'Stop en geef voorrang aan de voetganger',
          ar: 'توقف وأعط الأولوية للمشاة'
        }
      },
      {
        id: 'q-pc-2o2',
        text: {
          en: 'Continue driving, the light is green',
          nl: 'Blijf rijden, het licht is groen',
          ar: 'استمر في القيادة، الإشارة خضراء'
        }
      },
      {
        id: 'q-pc-2o3',
        text: {
          en: 'Honk to warn the pedestrian',
          nl: 'Toeter om de voetganger te waarschuwen',
          ar: 'استخدم البوق لتحذير المشاة'
        }
      }
    ],
    correctAnswerId: 'q-pc-2o1',
    explanation: {
      en: 'Even when the light is green for you, you must stop and give way to pedestrians who are already crossing or about to cross.',
      nl: 'Zelfs wanneer het licht groen is voor jou, moet je stoppen en voorrang verlenen aan voetgangers die al aan het oversteken zijn of op het punt staan over te steken.',
      ar: 'حتى عندما تكون الإشارة خضراء لك، يجب عليك التوقف وإعطاء الأولوية للمشاة الذين يعبرون بالفعل أو على وشك العبور.'
    },
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-3',
    text: {
      en: 'You are driving and see a pedestrian crossing at a school crossing. What should you do?',
      nl: 'Je rijdt en ziet een voetganger die oversteekt bij een schooloversteekplaats. Wat moet je doen?',
      ar: 'أنت تقود وترى أحد المشاة يعبر عند معبر مدرسة. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-pc-3o1',
        text: {
          en: 'Stop and give way to the pedestrian',
          nl: 'Stop en geef voorrang aan de voetganger',
          ar: 'توقف وأعط الأولوية للمشاة'
        }
      },
      {
        id: 'q-pc-3o2',
        text: {
          en: 'Continue driving, school crossings are not mandatory',
          nl: 'Blijf rijden, schooloversteekplaatsen zijn niet verplicht',
          ar: 'استمر في القيادة، معابر المدارس ليست إلزامية'
        }
      },
      {
        id: 'q-pc-3o3',
        text: {
          en: 'Honk to warn the pedestrian',
          nl: 'Toeter om de voetganger te waarschuwen',
          ar: 'استخدم البوق لتحذير المشاة'
        }
      }
    ],
    correctAnswerId: 'q-pc-3o1',
    explanation: {
      en: 'At school crossings, you must stop and give way to pedestrians, especially children, who are crossing or waiting to cross.',
      nl: 'Bij schooloversteekplaatsen moet je stoppen en voorrang verlenen aan voetgangers, vooral kinderen, die oversteken of wachten om over te steken.',
      ar: 'عند معابر المدارس، يجب عليك التوقف وإعطاء الأولوية للمشاة، خاصة الأطفال، الذين يعبرون أو ينتظرون العبور.'
    },
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-4',
    text: {
      en: 'You are turning right at a junction and see a pedestrian crossing the road you are turning into. What should you do?',
      nl: 'Je slaat rechtsaf op een kruising en ziet een voetganger die de weg oversteekt waar je naartoe draait. Wat moet je doen?',
      ar: 'أنت تنعطف يمينا عند تقاطع وترى أحد المشاة يعبر الطريق الذي تنعطف إليه. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-pc-4o1',
        text: {
          en: 'Stop and give way to the pedestrian',
          nl: 'Stop en geef voorrang aan de voetganger',
          ar: 'توقف وأعط الأولوية للمشاة'
        }
      },
      {
        id: 'q-pc-4o2',
        text: {
          en: 'Continue turning, pedestrians must wait',
          nl: 'Blijf draaien, voetgangers moeten wachten',
          ar: 'استمر في الانعطاف، يجب على المشاة الانتظار'
        }
      },
      {
        id: 'q-pc-4o3',
        text: {
          en: 'Honk to warn the pedestrian',
          nl: 'Toeter om de voetganger te waarschuwen',
          ar: 'استخدم البوق لتحذير المشاة'
        }
      }
    ],
    correctAnswerId: 'q-pc-4o1',
    explanation: {
      en: 'When turning at a junction, you must give way to pedestrians who are crossing the road you are turning into. (RVV 1990 art. 45)',
      nl: 'Bij het draaien op een kruising moet je voorrang verlenen aan voetgangers die de weg oversteken waar je naartoe draait. (RVV 1990 art. 45)',
      ar: 'عند الانعطاف عند تقاطع، يجب عليك إعطاء الأولوية للمشاة الذين يعبرون الطريق الذي تنعطف إليه. (RVV 1990 art. 45)'
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/pedestrian/q-pc-4-right-turn-pedestrian.jpg',
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-5',
    text: {
      en: 'Can you park your vehicle within 5 meters of a zebra crossing?',
      nl: 'Mag je je voertuig parkeren binnen 5 meter van een zebrapad?',
      ar: 'هل يمكنك إيقاف سيارتك على بعد 5 أمتار من معبر المشاة؟'
    },
    options: [
      {
        id: 'q-pc-5o1',
        text: {
          en: 'Yes, if it is marked with white lines',
          nl: 'Ja, als het gemarkeerd is met witte lijnen',
          ar: 'نعم، إذا كان محددا بخطوط بيضاء'
        }
      },
      {
        id: 'q-pc-5o2',
        text: {
          en: 'No, parking is prohibited within 5 meters of a crossing',
          nl: 'Nee, parkeren is verboden binnen 5 meter van een zebrapad',
          ar: 'لا، الوقوف محظور على بعد 5 أمتار من معبر المشاة'
        }
      },
      {
        id: 'q-pc-5o3',
        text: {
          en: 'Yes, as long as no pedestrians are present',
          nl: 'Ja, zolang er geen voetgangers aanwezig zijn',
          ar: 'نعم، طالما لا توجد مشاة'
        }
      }
    ],
    correctAnswerId: 'q-pc-5o2',
    explanation: {
      en: 'Parking is prohibited within 5 meters of a zebra crossing. This ensures that pedestrians have a clear view of approaching traffic and that drivers can see pedestrians approaching the crossing. (RVV 1990 art. 49)',
      nl: 'Parkeren is verboden binnen 5 meter van een zebrapad. Dit zorgt ervoor dat voetgangers een duidelijk uitzicht hebben op naderend verkeer en dat bestuurders voetgangers kunnen zien die het zebrapad naderen. (RVV 1990 art. 49)',
      ar: 'الوقوف محظور على بعد 5 أمتار من معبر المشاة. وهذا يضمن أن يكون لدى المشاة رؤية واضحة للحركة المقتربة وأن يتمكن السائقون من رؤية المشاة الذين يقتربون من المعبر. (RVV 1990 art. 49)'
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/pedestrian/q-pc-5-parking-prohibition.jpg',
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-6',
    text: {
      en: 'What is a priority for a pedestrian on a zebra crossing?',
      nl: 'Wat is het recht van voorrang voor een voetganger op een zebrapad?',
      ar: 'ما هي الأولوية للمشاة على معبر المشاة؟'
    },
    options: [
      {
        id: 'q-pc-6o1',
        text: {
          en: 'Pedestrians have no priority on a zebra crossing',
          nl: 'Voetgangers hebben geen voorrang op een zebrapad',
          ar: 'ليس للمشاة أولوية على معبر المشاة'
        }
      },
      {
        id: 'q-pc-6o2',
        text: {
          en: 'Pedestrians have absolute priority on a zebra crossing',
          nl: 'Voetgangers hebben absolute voorrang op een zebrapad',
          ar: 'للمشاة أولوية مطلقة على معبر المشاة'
        }
      },
      {
        id: 'q-pc-6o3',
        text: {
          en: 'Priority depends on pedestrian age',
          nl: 'Voorrang is afhankelijk van de leeftijd van de voetganger',
          ar: 'الأولوية تعتمد على عمر المشاة'
        }
      }
    ],
    correctAnswerId: 'q-pc-6o2',
    explanation: {
      en: 'Pedestrians have absolute priority on a zebra crossing. All drivers must stop and give way to pedestrians who are on or about to use the zebra crossing. (RVV 1990 art. 49)',
      nl: 'Voetgangers hebben absolute voorrang op een zebrapad. Alle bestuurders moeten stoppen en voorrang verlenen aan voetgangers die op het zebrapad zijn of ervan gebruik gaan maken. (RVV 1990 art. 49)',
      ar: 'للمشاة أولوية مطلقة على معبر المشاة. يجب على جميع السائقين التوقف وإعطاء الأولوية للمشاة الذين هم على المعبر أو على وشك استخدامه. (RVV 1990 art. 49)'
    },
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-7',
    text: {
      en: 'Should you reduce speed when approaching a zebra crossing?',
      nl: 'Moet je je snelheid verlagen wanneer je een zebrapad nadert?',
      ar: 'هل يجب عليك تقليل السرعة عند الاقتراب من معبر المشاة؟'
    },
    options: [
      {
        id: 'q-pc-7o1',
        text: {
          en: 'Only if pedestrians are visible',
          nl: 'Alleen als voetgangers zichtbaar zijn',
          ar: 'فقط إذا كان المشاة مرئيين'
        }
      },
      {
        id: 'q-pc-7o2',
        text: {
          en: 'Yes, always reduce speed and be prepared to stop',
          nl: 'Ja, verlaag altijd je snelheid en wees bereid om te stoppen',
          ar: 'نعم، قلل السرعة دائما واستعد للتوقف'
        }
      },
      {
        id: 'q-pc-7o3',
        text: {
          en: 'No, maintain constant speed',
          nl: 'Nee, behoud dezelfde snelheid',
          ar: 'لا، حافظ على نفس السرعة'
        }
      }
    ],
    correctAnswerId: 'q-pc-7o2',
    explanation: {
      en: 'You should always reduce speed when approaching a zebra crossing, even if no pedestrians are visible. Pedestrians may suddenly appear, so be prepared to stop at any time. (RVV 1990 art. 49)',
      nl: 'Je moet altijd je snelheid verlagen wanneer je een zebrapad nadert, zelfs als er geen voetgangers zichtbaar zijn. Voetgangers kunnen plotseling verschijnen, dus wees bereid om op elk moment te stoppen. (RVV 1990 art. 49)',
      ar: 'يجب عليك دائما تقليل السرعة عند الاقتراب من معبر المشاة، حتى لو لم يكن هناك مشاة مرئيين. قد يظهر المشاة فجأة، لذلك استعد للتوقف في أي وقت. (RVV 1990 art. 49)'
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/pedestrian/q-pc-7-approach-crossing.jpg',
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-8',
    text: {
      en: 'Can you overtake another vehicle at a zebra crossing?',
      nl: 'Mag je een ander voertuig inhalen bij een zebrapad?',
      ar: 'هل يمكنك تجاوز مركبة أخرى عند معبر المشاة؟'
    },
    options: [
      {
        id: 'q-pc-8o1',
        text: {
          en: 'Yes, if no pedestrians are present',
          nl: 'Ja, als er geen voetgangers aanwezig zijn',
          ar: 'نعم، إذا لم يكن هناك مشاة'
        }
      },
      {
        id: 'q-pc-8o2',
        text: {
          en: 'No, overtaking is prohibited at or near zebra crossings',
          nl: 'Nee, inhalen is verboden bij of in de buurt van zebrapaden',
          ar: 'لا، التجاوز محظور عند أو بالقرب من معابر المشاة'
        }
      },
      {
        id: 'q-pc-8o3',
        text: {
          en: 'Yes, if the road is wide enough',
          nl: 'Ja, als de weg breed genoeg is',
          ar: 'نعم، إذا كان الطريق واسعا بما يكفي'
        }
      }
    ],
    correctAnswerId: 'q-pc-8o2',
    explanation: {
      en: 'Overtaking is prohibited at or near zebra crossings. This ensures pedestrian safety and prevents accidents. Wait until you have passed the crossing area before attempting to overtake. (RVV 1990 art. 49)',
      nl: 'Inhalen is verboden bij of in de buurt van zebrapaden. Dit zorgt voor veiligheid van voetgangers en voorkomt ongelukken. Wacht tot je het zebrapad voorbij bent voordat je inhaalt. (RVV 1990 art. 49)',
      ar: 'التجاوز محظور عند أو بالقرب من معابر المشاة. وهذا يضمن سلامة المشاة ويمنع الحوادث. انتظر حتى تتجاوز منطقة المعبر قبل محاولة التجاوز. (RVV 1990 art. 49)'
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/pedestrian/q-pc-8-overtaking-prohibited.jpg',
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-9',
    text: {
      en: 'What should you do if traffic lights fail at a crossing that still has zebra markings?',
      nl: 'Wat moet je doen als verkeerslichten uitvallen op een zebrapad?',
      ar: 'ماذا يجب أن تفعل إذا فشلت إشارات المرور عند معبر به علامات المشاة؟'
    },
    options: [
      {
        id: 'q-pc-9o1',
        text: {
          en: 'Treat it as a normal crossing and proceed',
          nl: 'Behandel het als een normaal kruispunt en ga door',
          ar: 'تعامل معه كمعبر عادي وتقدم'
        }
      },
      {
        id: 'q-pc-9o2',
        text: {
          en: 'Treat it as a zebra crossing and give way to pedestrians',
          nl: 'Behandel het als een zebrapad en geef voorrang aan voetgangers',
          ar: 'تعامل معه كمعبر المشاة وأعط الأولوية للمشاة'
        }
      },
      {
        id: 'q-pc-9o3',
        text: {
          en: 'Stop and wait for lights to be repaired',
          nl: 'Stop en wacht tot de lichten zijn gerepareerd',
          ar: 'توقف وانتظر حتى يتم إصلاح الأضواء'
        }
      }
    ],
    correctAnswerId: 'q-pc-9o2',
    explanation: {
      en: 'If traffic lights fail but zebra markings are present, apply zebra-crossing rules and give way to pedestrians on or about to use the crossing. Approach at a speed that lets you stop safely. (RVV 1990 art. 49)',
      nl: 'Als verkeerslichten uitvallen maar zebramarkering aanwezig is, pas de zebrapad-regels toe en geef voorrang aan voetgangers op of die het kruispunt gaan gebruiken. Nader met een snelheid waarmee je veilig kunt stoppen. (RVV 1990 art. 49)',
      ar: 'إذا فشلت إشارات المرور ولكن علامات المشاة موجودة، طبق قواعد معبر المشاة وأعط الأولوية للمشاة على أو على وشك استخدام المعبر. اقترب بسرعة تسمح لك بالتوقف بأمان. (RVV 1990 art. 49)'
    },
    subject: 'Pedestrian Crossings'
  },
  {
    id: 'q-pc-10',
    text: {
      en: 'What is the difference between a zebra crossing and a pedestrian refuge island?',
      nl: 'Wat is het verschil tussen een zebrapad en een voetgangerseiland?',
      ar: 'ما الفرق بين معبر المشاة وجزيرة الملاذ للمشاة؟'
    },
    options: [
      {
        id: 'q-pc-10o1',
        text: {
          en: 'They are the same thing',
          nl: 'Ze zijn hetzelfde',
          ar: 'هي نفس الشيء'
        }
      },
      {
        id: 'q-pc-10o2',
        text: {
          en: 'A zebra crossing is on the road; a refuge island divides the road in two',
          nl: 'Een zebrapad bevindt zich op de weg; een voetgangerseiland deelt de weg in tweeën',
          ar: 'معبر المشاة موجود على الطريق؛ جزيرة الملاذ تقسم الطريق إلى نصين'
        }
      },
      {
        id: 'q-pc-10o3',
        text: {
          en: 'A refuge island is only for elderly people',
          nl: 'Een voetgangerseiland is alleen voor ouderen',
          ar: 'جزيرة الملاذ فقط للمسنين'
        }
      }
    ],
    correctAnswerId: 'q-pc-10o2',
    explanation: {
      en: 'A zebra crossing is a marked crossing area on the road where pedestrians cross in one stage. A pedestrian refuge island divides the road, allowing pedestrians to cross in two stages with a safe waiting area in the middle. (RVV 1990 art. 5)',
      nl: 'Een zebrapad is een gemarkeerde oversteekplaats op de weg waar voetgangers in één keer oversteken. Een voetgangerseiland deelt de weg, zodat voetgangers in twee fasen kunnen oversteken met een veilige wachtruimte in het midden. (RVV 1990 art. 5)',
      ar: 'معبر المشاة هو منطقة عبور محددة على الطريق حيث يعبر المشاة في مرحلة واحدة. جزيرة الملاذ للمشاة تقسم الطريق، مما يسمح للمشاة بالعبور على مرحلتين مع منطقة انتظار آمنة في المنتصف. (RVV 1990 art. 5)'
    },
    subject: 'Pedestrian Crossings'
  }
];
